"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryItemError = void 0;
const errors_1 = require("@deliverr/errors");
class InventoryItemError extends errors_1.AbstractDeliverrError {
    constructor(code, ex) {
        var _a, _b;
        super({
            code,
            message: code,
            payload: { dskus: (_b = (_a = ex.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.dskus },
        });
    }
    get dskus() {
        var _a;
        return (_a = this.payload) === null || _a === void 0 ? void 0 : _a.dskus;
    }
}
exports.InventoryItemError = InventoryItemError;
//# sourceMappingURL=InventoryItemError.js.map